// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'Premešteno: ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accButtonProgressComplete: (p: { label: string }) => 'Radnja je u završena: ' + p['label'],
  accButtonProgressStatus: (p: { label: string }) => 'Radnja je u toku: ' + p['label'],
  accColorPalette: () => 'Paleta boja',
  accColorSwatch: () => 'Uzorci boja',
  accCommandKey: () => 'Komanda',
  accContextMenuLabel: () => 'radnje',
  accControlKey: () => 'Zatvori',
  accPositionAfter: () => 'posle',
  accPositionBefore: () => 'pre',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Pritisnite i zadržite taster ' +
    p['keyPressed'] +
    ' i tastere shift, pa upotrebite tastere sa strelicama da biste promenili redosled.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Unesite ceo datum, ovako: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Unesite mesec i godinu, ovako: ' + p['dateExample'] + '.',
  chart_labelDataLabel: () => 'Oznaka',
  chart_labelGroup: () => 'Grupa',
  chart_labelSeries: () => 'Serija',
  chart_labelValue: () => 'Vrednost',
  chart_labelWidthWeight: () => 'Z',
  chart_labelX: () => 'X',
  chart_labelY: () => 'Y',
  checkboxSet_requiredMessageDetail: () => 'Izaberite vrednost.',
  checkbox_helpForCheckbox: () => 'Pomoć za polje za potvrdu',
  checkbox_requiredMessageDetail: () => 'Izaberite vrednost.',
  checkbox_selected: () => 'Polje za potvrdu je označeno',
  checkbox_unselected: () => 'Polje za potvrdu nije označeno',
  close: () => 'Zatvori',
  collection_apply: () => 'Primeni',
  collection_cancel: () => 'Otkaži',
  collection_loaded: () => 'Učitano',
  collection_loading: () => 'Učitava se',
  collection_noData: () => 'Nema podataka za prikaz.',
  collection_pixels: () => 'piks.',
  collection_resizeColumnDialog: () => 'Promena veličine kolone',
  collection_resizeColumnMenu: () => 'Promena veličine kolone...',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    'Unesite broj između ' + p['MIN'] + ' i ' + p['MAX'] + '.',
  collection_selectAllRows: () => 'Izaberi sve redove',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Izaberite red ' + p['ROW_NAME'],
  collection_sortAscendingSubMenu: () => 'Rastuće',
  collection_sortColumnMenu: () => 'Sortiraj kolone',
  collection_sortDescendingSubMenu: () => 'Opadajuće',
  collection_sortDisabled: () => 'Ne može da se sortira',
  collection_sortEnabled: () => 'Može da se sortira',
  collection_width: () => 'Širina',
  colorPicker_label: () => 'Birač boja',
  confirmation: () => 'Potvrda',
  datePicker_currentDate: () => 'Trenutni datum',
  datePicker_goToToday: () => 'Idi na danas',
  datePicker_label: () => 'Birač datuma',
  datePicker_month: () => 'Mesec',
  datePicker_months: () => 'Meseci',
  datePicker_next: () => 'Sledeće',
  datePicker_nextDecade: () => 'Sledeća decenija',
  datePicker_nextMonth: () => 'Sledeći mesec',
  datePicker_prev: () => 'Prethodno',
  datePicker_prevDecade: () => 'Prethodna decenija',
  datePicker_prevMonth: () => 'Prethodni mesec',
  datePicker_restricted: () => 'Ograničeno',
  datePicker_selected: () => 'Izabrano',
  datePicker_today: () => 'danas',
  datePicker_weekNum: (p: { NUM: string }) => 'Nedelja ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'Broj nedelje',
  datePicker_year: () => 'Godina',
  datePicker_years: () => 'Godine',
  diagram_promotedLink: () => '1 veza',
  diagram_promotedLinkAriaDesc: () => 'Indirektno',
  diagram_promotedLinks: (p: { num_links: string }) => 'Broj veza: ' + p['num_links'],
  error: () => 'Greška',
  expandableList_expandCollapseInstructionText: () =>
    'Koristite strelice da biste proširivali i skupljali',
  expandableList_groupCollapse: () => 'Skupljeno',
  expandableList_groupExpand: () => 'Prošireno',
  filePicker_addFiles: () => 'Dodaj datoteke',
  filePicker_dropzonePrimaryText: () => 'Prevucite i otpustite',
  filePicker_dropzoneSecondaryText: () => 'Izaberite datoteku ili je otpustite ovde',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Izaberite ili prevucite datoteke ovde',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Ne možete da otpremate datoteke tipa: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Otpremajte jednu po jednu datoteku',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Ne možete da otpremate datoteke tipa ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'nepoznato',
  formControl_clear: () => 'Obriši',
  formControl_day: () => 'Dan',
  formControl_empty_segment: () => 'Prazno',
  formControl_helpAvailable: () => 'Pomoć je dostupna',
  formControl_hide: () => 'Sakrij',
  formControl_hour: () => 'Sat',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Dostigli ste ograničenje od ' +
    ((
      {
        one: new Intl.NumberFormat('sr-Latn').format(p['CHARACTER_LIMIT']) + ' znaka',
        few: new Intl.NumberFormat('sr-Latn').format(p['CHARACTER_LIMIT']) + ' znaka'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('sr-Latn').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('sr-Latn').format(p['CHARACTER_LIMIT']) + ' znakova') +
    '.',
  formControl_loading: () => 'Učitava se',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Ne možete da unesete više od sledećeg broja znakova: ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Maksimalna dužina od ' + p['MAX_LENGTH'] + ' je premašena.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Preostali broj znakova je ' + p['CHARACTER_COUNT'] + '.',
  formControl_millisecond: () => 'Milisekunda',
  formControl_minute: () => 'Minut',
  formControl_month: () => 'Mesec',
  formControl_readOnly: () => 'Samo za čitanje',
  formControl_requiredMessageDetail: () => 'Unesite vrednost.',
  formControl_second: () => 'Sekunda',
  formControl_selectionExactMessageDetail: (p: { n: string }) =>
    'Izaberite ' + p['n'] + ' vrednost(i).',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    'Dostigli ste ograničenje za izbor: ' + p['max'] + '.',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    'Izaberite od ' + p['min'] + ' do ' + p['max'] + ' vrednosti.',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    'Izaberite najmanje ' + p['min'] + ' vrednost(i).',
  formControl_show: () => 'Prikaži',
  formControl_year: () => 'Godina',
  gantt_labelDate: () => 'Datum',
  gantt_labelEnd: () => 'Kraj',
  gantt_labelLabel: () => 'Oznaka',
  gantt_labelRow: () => 'Red',
  gantt_labelStart: () => 'Početak',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nisu pronađeni odeljci koji se podudaraju.',
  indexer_keyboardInstructionText: () => "Pritisnite 'enter' da biste izabrali vrednost.",
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Između ' + p['FROM_SECTION'] + ' i ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Dvaput dodirnite i zadržite da biste prešli na režim gestikulacije, a zatim prevucite nagore ili nadole da biste prilagodili vrednost.',
  info: () => 'Informacije',
  inputColor_selectColor: () => 'Izaberite boju',
  inputDateMask_date_cleared: () => 'Datum je obrisan',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Prazno',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'gggg',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Unesite datum koji je ' + p['max'] + ' ili raniji.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Unesite datum koji je ' + p['min'] + ' ili kasniji.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Unesite dostupan datum.',
  inputDatePicker_instruction: () => 'Pritisnite tabulator da biste pristupili kalendaru.',
  inputDatePicker_selectDate: () => 'Izaberite datum',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Unesite mesec i godinu koji su ' + p['max'] + ' ili ranije.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Unesite mesec i godinu koji su ' + p['min'] + ' ili kasnije.',
  inputNumber_converterParseError: () => 'Unesite broj.',
  inputNumber_decrease: () => 'Smanji',
  inputNumber_increase: () => 'Povećaj',
  inputPassword_hidden: () => 'Lozinka je skrivena',
  inputPassword_hide: () => 'Sakrij lozinku',
  inputPassword_show: () => 'Prikaži lozinku',
  inputSensitiveText_hidden: () => 'Osetljivi tekst je skriven',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    'Unesite vreme koje je ' + p['max'] + ' ili ranije.',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Unesite vreme koje je ' + p['min'] + ' ili kasnije.',
  inputTimeMask_time_cleared: () => 'Vreme je obrisano',
  labelNone: () => 'Nijedno',
  list_msgFetchCompleted: () => 'Učitano',
  list_msgFetchingData: () => 'Učitava se',
  list_suggestion: () => 'Predlog',
  menu_stateLoading: () => 'Učitava se',
  messageToast_allMessagesClosed: () => 'Sve iskačuće poruke su zatvorene.',
  message_close: () => 'Zatvori',
  message_confirmation: () => 'Uspešno',
  message_error: () => 'Greška',
  message_info: () => 'Informacije',
  message_navigationFromMessagesRegion: () =>
    'Prelazak na oblast za poruke. Pritisnite F6 da biste se kretali.',
  message_navigationToMessagesRegion: () =>
    'U regionu za poruke ima novih poruka. Pritisnite F6 da biste se kretali.',
  message_navigationToTouch: () => 'U regionu za poruke ima novih poruka.',
  message_warning: () => 'Upozorenje',
  noData_message: () => 'Nema stavki za prikaz',
  overflowItemLabel: () => 'Još kartica',
  plural_separator: () => ', ',
  popup_close_skipLink: () => 'Dvaput dodirnite da biste zatvorili otvoreni iskačući prozor.',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    'Prelazak u iskačući prozor. Pritisnite F6 da biste prelazili između iskačućeg prozora i povezane kontrole.',
  popup_liveRegion_F6_initial_focus_none: () =>
    'Otvoren je iskačući prozor. Pritisnite F6 da biste prelazili između iskačućeg prozora i povezane kontrole.',
  progressIndeterminate: () => 'U toku',
  radioButton_checked: () => 'Radio dugme je označeno',
  radioButton_selected: () => 'Radio dugme je izabrano',
  radioButton_unchecked: () => 'Radio dugme nije označeno',
  radioButton_unselected: () => 'Radio dugme nije izabrano',
  radio_helpForRadio: () => 'Pomoć za radio dugme',
  radio_requiredMessageDetail: () => 'Izaberite vrednost.',
  selectMultiple_apply: () => 'Primeni',
  selectMultiple_back: () => 'Nazad',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Koristite strelice nalevo i nadesno da biste označili izabrane vrednosti.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Pritisnite tastere Backspace ili Delete da biste uklonili izabranu vrednost.',
  selectMultiple_selectedValues: () => 'Izabrane vrednosti',
  selectMultiple_showSelectedValues: () => 'Prikazuju se samo izabrane vrednosti.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Izabranih vrednosti: ' + p['VALUE_COUNT'] + ' .',
  select_addToList: () => 'Dodaj na listu',
  select_addToListAvailable: () => 'Dodavanje na listu je dostupno',
  select_closeDropdown: () => 'Pritisnite taster Escape da biste zatvorili.',
  select_moreSearchOptions: () => 'Više opcija pretraživanja',
  select_moreSearchOptionsAvailable: () => 'Više opcija pretraživanja je dostupno',
  select_noMatchesFound: () => 'Nije pronađen nijedan pogodak.',
  select_oneMatchFound: () => 'Pronađen je jedan rezultat',
  select_requiredMessageDetail: () => 'Izaberite vrednost.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Pronađenih podudaranja: ' + p['TOTAL_SIZE'],
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Pronađenih podudaranja: ' + p['TOTAL_SIZE'] + ' ili više',
  selectorAll_deselectAll: () => 'Opozovi izbor svega',
  selectorAll_selectAll: () => 'Izaberi sve',
  selector_selected: () => 'Polje za potvrdu je označeno',
  selector_unselected: () => 'Polje za potvrdu nije označeno',
  sheet_close: () => 'Zatvori',
  switch_off: () => 'Isključeno',
  switch_on: () => 'Uključeno',
  tabBarNavigationList_removeCueText: () => 'Može da se ukloni',
  tabBar_tabContainsErrors: () => 'Sadrži greške',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) => 'Uklonjeno: ' + p['itemKey'],
  tabbar_labelContextMenu: () => 'ima kontekstualni meni',
  tabbar_labelMoveLeft: () => 'Pomeri nalevo',
  tabbar_labelMoveRight: () => 'Pomeri nadesno',
  tabbar_labelRemove: () => 'Ukloni',
  timeComponent_tooltipZoomIn: () => 'Uvećaj',
  timeComponent_tooltipZoomOut: () => 'Umanji',
  timeConverter_parseError: () => 'Unesite kompletno vreme.',
  train_current: () => 'Trenutno',
  train_message_type: () => 'Tip poruke',
  train_not_visited: () => 'Nije posećeno',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Korak ' + p['currentStep'] + ' od ' + p['numberOfSteps'],
  train_visited: () => 'Posećeno',
  userAssistance_learnMore: () => 'Saznajte više',
  userAssistance_required: () => 'Obavezno',
  vis_clearSelection: () => 'Obriši izbor',
  vis_drillable: () => 'Može da se detaljno analizira',
  vis_invalidData: () => 'Nevažeći podaci',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' od ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Izbor pomičnog teksta',
  vis_marqueeZoomTooltip: () => 'Uvećavanje pomičnog teksta',
  vis_noData: () => 'Nema podataka za prikaz',
  vis_panTooltip: () => 'Pomeranje',
  vis_stateCollapsed: () => 'Skupljeno',
  vis_stateExpanded: () => 'Prošireno',
  vis_stateLoaded: () => 'Učitano',
  vis_stateLoading: () => 'Učitava se',
  vis_stateSelected: () => 'Izabrano',
  vis_stateUnselected: () => 'Neizabrano',
  warn: () => 'Upozorenje'
};
export default bundle;
